export type StatementType = 'cashflow' | 'income' | 'balance';
export type ValueMode = 'category' | 'portioned';

export const STATEMENT_CONFIG = {
  cashflow: {
    title: 'CASH FLOW STATEMENT',
    lineChart: { categoryCode: 30, title: 'Net Cash', yAxisLabel: 'Net Cash' },
    barChart: { categoryCode: 5, title: 'Cash Out from Operations' },
  },
  income: {
    title: 'INCOME STATEMENT',
    lineChart: { categoryCode: 24, title: 'Net Operating Income', yAxisLabel: 'Net Operating Income' },
    barChart: { categoryCode: 4, title: 'Operating Expenses' },
  },
  balance: {
    title: 'BALANCE SHEET',
    lineChart: { categoryCode: 10, title: 'Liabilities & Equity', yAxisLabel: 'Liabilities & Equity' },
    barChart: { categoryCode: 4, title: 'NET Furniture, Fixtures & Equipment' },
  },
} as const;

export const STATEMENT_TYPE_OPTIONS = [
  { value: 'cashflow' as const, label: 'Cash Flow Statement' },
  { value: 'income' as const, label: 'Income Statement' },
  { value: 'balance' as const, label: 'Balance Sheet' },
];

export const VALUE_MODE_OPTIONS = [
  { value: 'portioned' as const, label: 'Portioned' },
  { value: 'category' as const, label: 'Whole' },
];

export const DEFAULT_LINE_COLOR = 'info';

export function getStatementConfig(type: StatementType) {
  return STATEMENT_CONFIG[type] ?? STATEMENT_CONFIG.cashflow;
}
